import { render, staticRenderFns } from "./AddRole.vue?vue&type=template&id=7c572208&scoped=true&"
import script from "./AddRole.vue?vue&type=script&lang=js&"
export * from "./AddRole.vue?vue&type=script&lang=js&"
import style0 from "./AddRole.vue?vue&type=style&index=0&id=7c572208&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c572208",
  null
  
)

export default component.exports